import React from "react";
import AdminManageAdmins from "../../components/admin/components/AdminManageAdmins";

const ManageAdmins = () => {
  return <AdminManageAdmins />;
};

export default ManageAdmins;
